module.exports = __webpack_public_path__ + "img/play-v2.4866a832.svg";